import { InjectionToken } from '@angular/core';

export interface ClaimLineTypesConfiguration {
  funeral: {
    id: number;
    name: string;
  };
  hospitalCashback: {
    id: number;
    name: string;
  };
  personalAccidentCover: {
    id: number;
    name: string;
  };
  zfu: {
    id: number;
    name: string;
  };
}

export const CLAIM_LINE_TYPES_CONFIGURATION = new InjectionToken<
  ClaimLineTypesConfiguration
>('Configure Claim Types Configuration');
